import classes from './Navbar.module.css';
import React, { useContext } from 'react';
import menu from '../assets/svg/menu.svg';
import keeplogo from '../assets/image/keeplogo.png';
import refresh from '../assets/svg/refresh.svg';
import setting from '../assets/svg/setting.svg';
import view from '../assets/svg/view.svg';
import NotesContext from '../store/notes-context';

export default function Navbar(props) {
  const notesCtx = useContext(NotesContext);
  console.log(notesCtx.searchText);
  const onSearch = (e) => {
    notesCtx.setSearchText(e.target.value);
  };

  return (
    <div className={classes.navbar}>
      <div className={classes['nav-left']}>
        <button onClick={props.toggleSidebar}>
          <img className={classes.menu} src={menu} alt="menu" />
        </button>
        <button>
          <img src={keeplogo} alt="keep logo" />
        </button>
        <span>Keep</span>
      </div>

      <div className={classes['nav-centre']}>
        <input
          className={classes.inp}
          type="text"
          placeholder="Search"
          onChange={onSearch}
        />
        <div className={classes.view}>
          <button>
            <img src={refresh} alt="refresh" />
          </button>
          <button>
            <img src={view} alt="change view" />
          </button>
          <button>
            <img src={setting} alt="settings" />
          </button>
        </div>
      </div>
      <div className={classes['nav-right']}>
        <span>Profile</span>
      </div>
    </div>
  );
}
